import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'

const Container = styled.div`
  position: absolute;
  bottom: 120%;
  right: 5px;
  border: 2px solid #ddd;
  background: #fff;
  width: 300px;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.3);
`

const ImageContainer = styled.div`
  flex: none;
  width: 46px;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    max-width: 100%;
    max-height: 100%;
  }
`

const Message = styled.div`
  color: #000;
  padding: 5px;
`

class Alert extends Component {
  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true)
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this)

    if (!domNode || !domNode.contains(event.target)) {
      this.props.hideAlert()
    }
  }

  render() {
    const { mensaje } = this.props
    return (
      <Container>
        <ImageContainer>
          <img src="/images/iconos/alert.png" alt={mensaje} />
        </ImageContainer>
        <Message>{mensaje}</Message>
      </Container>
    )
  }
}

export default Alert
